<template>
    <div :class="one ? 'container containerNew' : 'container'">
        <div class="common-header-wrap">
            <mt-header :title="$t('hunt4')" class="common-header">
                <mt-button slot="left" icon="back" @click="one ? onPage('index') : $router.go(-1)"></mt-button>
            </mt-header>
        </div>

        <img class="bg" src="../../../assets/image/one/hunt_convert.png" alt="">
        <div class="text">
            <div>{{ $t('hunt2') }}</div>
            <div>{{ $t('hunt3') }}</div>
        </div>

        <div class="convert">
            <div class="convert_tle">{{ $t('hunt4') }}</div>
            <img class="convert_f" src="../../../assets/image/one/hunt_convert_f.png" alt="">
            <!-- <div class="convert_inp" style="margin-bottom: 5px;">
                <input type="text" v-model="username" :placeholder="$t('new26')">
            </div> -->
            <div class="convert_inp">
                <input type="text" v-model="exchange_code" :placeholder="$t('hunt8')">
            </div>
            <div class="convert_text">
                <img src="../../../assets/image/one/hunt_convert_g.png" alt="">
                <span>{{ $t('hunt9') }}</span>
            </div>

            <div class="convert_btn" @click="onExchange">
                <img src="../../../assets/image/one/hunt_convert_btn.png" alt="">
                <span>{{ $t('hunt7') }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import { Exchange, GetExchangeCode } from '../../../api/memberOne'
import { Toast } from 'mint-ui'
export default {
    name: 'HuntConvert',
    props: {
        one: {
            default: false,
            type: Boolean
        },
        objData: {
            default: () => { },
            type: Object
        }
    },
    data() {
        return {
            exchange_code: '',
            username: ''
        }
    },
    created(){},
    mounted(){
        if(this.objData.id || this.objData.activity_id){
            const activity_id = this.objData.activity_id || this.objData.id
            this.onGetExchangeCode(activity_id)
        }
    },
    methods: {
        onExchange(){
            const { exchange_code, username } = this
            Exchange({
                exchange_code,
                username
            }).then(res=>{
                Toast(res.message);
                if (res.code === 10000) {
                    setTimeout(() => {
                        this.$emit('onPage', 'index')
                    }, 1000);
                }
            })
        },
        onGetExchangeCode(activity_id) {
            GetExchangeCode({
                activity_id,
            }, 'one').then(res => {
                this.exchange_code = res.result.exchange_code
            })
        },
        onPage(v, val) {
            this.$emit('onPage', v, val)
        },
    }
}
</script>
<style lang="scss" scoped>
.containerNew{
    height: 100% !important;
}
.container {
    display: flex;
    flex-direction: column;
    width: 100vw;
    height: 100vh;
    position: relative;
    overflow: hidden;

    .bg {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
    }

    .text{
        position: absolute;
        top: 25%;
        left: 50%;
        width: 70%;
        transform: translate(-50%, -50%);
        color: #CB1B19;
        font-size: 30px;
        font-weight: bold;
        div:nth-child(1){
            text-align: left;
        }
        div:nth-child(2){
            text-align: right;
        }
    }

    .convert {
        position: absolute;
        font-size: 27px;
        top: 60%;
        left: 50%;
        width: 60%;
        transform: translate(-50%, -50%);
        font-weight: bold;
        color: #FFD4AA;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .convert_tle {
            font-size: 24px;
            color: #D41E16;
            font-weight: bold;
        }

        .convert_f {
            width: 80%;
            height: auto;
            padding: 0 0 5px;
        }

        .convert_inp {
            width: 100%;

            input {
                width: 100%;
                // height: 57px;
                border-radius: 6px;
                border: none;
                outline: none;
                padding: 10px 15px;
                box-sizing: border-box;
                margin: 0;
                background: #fff;
                color: #666;
                font-size: 16px;
                box-shadow: none;
                appearance: none;
                -webkit-appearance: none;
                font-weight: 500;
            }
        }

        .convert_text {
            width: 100%;
            font-size: 15px;
            color: #D41E16;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            padding: 10px 0 10px;

            img {
                width: 14px;
                height: 14px;
                margin-right: 5px;
            }
        }
        .convert_btn{
            width: 80%;
            position: relative;
            font-weight: 800;
            font-size: 16px;
            color: #D41E16;
            line-height: 43px;
            height: 66px;
            display: flex;
            justify-content: center;
            align-items: center;
            span{
                z-index: 1;
                position: sticky;
                margin-top: -6px;
            }
            img{
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                z-index: 0;
            }
        }
    }
}
</style>
